<template>
  <li
    class="sns-icon-content"
    :style="{height: height + 'px'}"
  >
    <div class="flex">
      <div class="sns-handle" title="ドラッグ＆ドロップで並び順を変更"/>
      <img :src="attrs.src" width="40px" height="40px">
      <edit-sns-select-box
        v-if="partsContainerType === 'FollowButton'"
        :value="dataSnsName"
        :partsContainerType="partsContainerType"
        @updateValue="updateValue($event)"
      />
      <edit-share-part-sns-select-box
        v-else-if="partsContainerType === 'Share'"
        :value="dataSnsName"
        :type="'change'"
        :partExistsSns="partExistsSns"
        @updateValue="updateValue($event)"
      />
      <!-- 削除ボタン -->
      <button
        v-if="showSnsDeleteButton"
        type="button"
        @click="snsDeleteButton()"
        class="delete"
      >
        削除
      </button>
      <!-- アコーディオンボタン -->
      <button
        v-if="partsContainerType === 'FollowButton'"
        class="accordion"
        :class="{open: isOpenAll}"
        @click="toggleOpenDetail"
      >
        <i class="fas fa-angle-down"></i>
      </button>
    </div>
    <!-- リンクテキスト -->
    <edit-alt :ids="ids" :attrs="attrs"/>
    <!-- リンクURL -->
    <edit-link
      v-if="partsContainerType === 'FollowButton'"
      :ids="ids"
      :attrs="attrs"
      :partsContainerType="partsContainerType"
    />
  </li>
</template>

<script>
import EditSnsSelectBox from '@/components/Content/Palette/CommonLayouts/EditSnsSelectBox'
import EditSharePartSnsSelectBox from '@/components/Content/Palette/EditPartDesign/Editor/Share/EditSharePartSnsSelectBox.vue'
import EditAlt from '@/components/Content/Palette/EditPartDesign/Layouts/EditAlt'
import EditLink from '@/components/Content/Palette/EditPartDesign/Layouts/EditLink'
import FollowButtonBase from '@/components/Content/Palette/EditPartDesign/Editor/FollowButton/FollowButtonBase'

const CLOSE_CONTENTS_HEIGHT = 62
const OPEN_CONTENTS_HEIGHT = 208
const OPEN_CONTENTS_HEIGHT_4_EMAIL = 330
const SHARE_PARTS_CONTENTS_HEIGHT = 130

export default {
  props: [
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partId',
    'attrs',
    'partsLength',
    'partExistsSns',
  ],
  mixins: [
    FollowButtonBase,
  ],
  data () {
    return {
      isOpenAll: false,
      height: CLOSE_CONTENTS_HEIGHT,
    }
  },
  components: {
    EditSnsSelectBox,
    EditSharePartSnsSelectBox,
    EditAlt,
    EditLink,
  },
  computed: {
    ids () {
      return {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
      }
    },
    // パーツ数が2以上の場合のみ、削除ボタンを表示
    showSnsDeleteButton () {
      return this.partsLength > 1
    },
    dataSnsName () {
      return this.attrs['data-sns-name']
    }
  },
  methods: {
    updateValue (event) {
      // mixinの処理からattrs取得
      const newSnsIcon = this.getSnsIconDefaultAttrs(event)
      if (!newSnsIcon) return
      this.$store.commit('updateSnsIcon', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        newSnsIcon: newSnsIcon,
      })
      this.getHeight(this.dataSnsName)
    },
    snsDeleteButton () {
      this.$store.commit('deleteSNSIconPart', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
      })
    },
    toggleOpenDetail () {
      this.isOpenAll = !this.isOpenAll
      this.getHeight(this.dataSnsName)
    },
    getHeight (snsName) {
      if (this.partsContainerType === 'Share') {
        this.height = SHARE_PARTS_CONTENTS_HEIGHT
      } else if (this.isOpenAll) {
        this.height = snsName === 'Email' ? OPEN_CONTENTS_HEIGHT_4_EMAIL : OPEN_CONTENTS_HEIGHT
      } else {
        this.height = CLOSE_CONTENTS_HEIGHT
      }
    }
  },
  created () {
    this.getHeight(this.dataSnsName)
  },
  watch: {
    dataSnsName (value) {
      this.getHeight(value)
    },
  }
}
</script>

<style lang="scss" scoped>
.sns-icon-content {
  border-top: #dbdbdb 1px solid;
  background: #fff;
  width: 100%;
  min-height: 62px;
  padding: 20px 20px 0;
  box-sizing: border-box;
  transition: all 0.3s ease 0s;
  overflow: hidden;
  &:last-of-type {
    border-bottom: #dbdbdb 1px solid;
  }
  .flex {
    display: flex;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 10px;
    margin-top: -20px;
    margin-left: -20px;
    position: relative;
    // SNSアイコン
    img {
      margin-right: 8px;
    }
  }
  // ドラッグ＆ドロップ 掴むためのハンドル
  .sns-handle {
    margin-right: 8px;
    &::before {
      color: #dbdbdb;
      content: '\f0c9';
      cursor: pointer;
      font-family: "Font Awesome 5 Free";
      font-size: 24px;
      font-weight: 900;
    }
  }

  // 削除ボタン
  .delete {
    height: 39px;
    line-height: 39px;
    white-space: nowrap;
    font-weight: 300;
    border-radius: 2px;
    transition: all 0.3s ease 0s;
    padding: 0 15px;
    margin: 0 5px;
    cursor: pointer;
    &:hover, &:active {
      background: #e4e4e4;
      transition: all 0.3s ease 0s;
      border-radius: 2px;
    }
    &::before {
      font-family: "Font Awesome 5 Free";
      display: inline-block;
      text-align: center;
      content: '\f2ed';
    }
  }
  // アコーディオンボタン
  .accordion {
    font-size: 20px;
    width: 60px;
    height: 60px;
    user-select: none;
    cursor: pointer;
    position: absolute;
    top: 1px;
    right: -20px;
    transition: all 0.1s ease 0s;
    &.open {
      transform: rotate(180deg);
    }
  }
}
</style>

<style lang="scss">
.sns-icon-content {
  .email-box {
    >div {
      height: 45px;
    }
  }
}
</style>
